import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { Button, List, Typography, Flex } from "antd";
import Message from "./message";
import { DownCircleTwoTone } from "@ant-design/icons";
// import MessageImage from "./MessageImage";

export default class MessagesList extends Component {
  constructor(props) {
    super(props);

    this.chatRef = createRef();
    this.state = {
      isObservableNewMessages: true,
      loadingEarlierMessages: false,
    };
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate() {
    if (this.state.isObservableNewMessages && this.props.messages.length > 0)
      this.scrollToBottom();
  }

  componentDidMount() {
    if (this.state.isObservableNewMessages && this.props.messages.length > 0)
      this.scrollToBottom();
  }

  scrollToBottom = () => {
    this.chatRef.current.scrollTo(0, this.chatRef.current.scrollHeight);
  };

  handleContainerScroll = (e) => {
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    const bottom = scrollHeight - scrollTop <= clientHeight + 10;
    if (bottom) return this.setState({ isObservableNewMessages: true });
    if (this.state.isObservableNewMessages)
      this.setState({ isObservableNewMessages: false });
  };

  getEarlierMessages = () => {
    if (!this.props.getEarlierMessages) return;
    this.setState({ loadingEarlierMessages: true });
    const firstMessage = this.props.messages[0];
    this.props
      .getEarlierMessages()
      .then(() => {
        if (!firstMessage) return;
        document
          .getElementById(`chat_item_${firstMessage.id}`)
          .scrollIntoView();
      })
      .finally(() => {
        this.setState({ loadingEarlierMessages: false });
      });
  };

  renderMessage = (message) => {
    const premium = this.props.premiums.find(
      (i) => i.premiumPurchaseId == message.premiumPurchaseId
    );
    return (
      <Message
        key={message.id}
        {...message}
        isOld={message.isOld}
        premiumName={premium?.title || "Unknown premium"}
      />
    );
  };

  render() {
    const { messages } = this.props;

    return (
      <Flex style={{ position: "relative", flex: 1 }} vertical>
        <Flex
          style={{ flex: 1, overflow: "scroll" }}
          vertical
          ref={this.chatRef}
          onScroll={this.handleContainerScroll}
        >
          <List
            header={
              <Flex justify="center">
                <Button
                  loading={this.state.loadingEarlierMessages}
                  type="primary"
                  onClick={this.getEarlierMessages}
                >
                  load messages
                </Button>
              </Flex>
            }
            style={{ height: 1, display: "flex", flexDirection: "column" }}
            vertical
            dataSource={messages}
            renderItem={this.renderMessage}
          />
        </Flex>
        {!this.state.isObservableNewMessages && (
          <DownCircleTwoTone
            style={{
              fontSize: 30,
              position: "absolute",
              zIndex: 2,
              top: "90%",
              right: "5%",
            }}
            onClick={this.scrollToBottom}
          />
        )}
        <Typography.Text type="secondary">
          {this.props.isTyping ? "User is typing..." : "\u0000"}
        </Typography.Text>
      </Flex>
    );
  }
}

MessagesList.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object).isRequired,
  renderMessage: PropTypes.func,
  reloadMessages: PropTypes.func,
  premiums: PropTypes.array,
};

MessagesList.defaultProps = {
  onStartTyping: () => null,
  onEndTyping: () => null,
  reloadMessages: null,
  premiums: [],
};
